import { useEffect, useState } from "react";

export type ServerConnectionState = "checking" | "online" | "offline";

export function useServerConnection(enabled = true): ServerConnectionState {
  const [status, setStatus] = useState<ServerConnectionState>("checking");
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const check = async () => {
      if (!navigator.onLine) {
        if (active) setStatus("offline");
        return;
      }
      try {
        const response = await fetch("/api/health", {
          cache: "no-store",
          credentials: "same-origin",
          signal: AbortSignal.timeout(5_000),
        });
        if (active) setStatus(response.ok ? "online" : "offline");
      } catch {
        if (active) setStatus("offline");
      }
    };
    const handleOnline = () => {
      setStatus("checking");
      void check();
    };
    const handleOffline = () => setStatus("offline");
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    void check();
    const interval = window.setInterval(() => void check(), 15_000);
    return () => {
      active = false;
      window.clearInterval(interval);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [enabled]);
  return status;
}
